import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class PortalTenantInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiRequest = req.url.includes('/portal/') || req.url.includes('/coverage/customer/');

    if (isApiRequest) {
      const hostname = window.location.hostname;
      const port = window.location.port;

      const tenantHost = port ? `${hostname}:${port}` : hostname;

      const modifiedReq = req.clone({
        setHeaders: {
          'X-Portal-Tenant-Host': tenantHost
        }
      });

      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
